"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagManager = void 0;
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
var FlagManager = /** @class */ (function () {
    function FlagManager(_a) {
        var _this = this;
        var showLog = _a.showLog;
        this.listeners = new Map();
        /**
         *
         *
         * @param {(featureName: string, value: boolean) => void} onFeatureFlagChange
         * @memberof FlagManager
         * listen to feature flag change
         * return: unlisten function
         */
        this.listen = function (onFeatureFlagChange) {
            _this.listeners.set(onFeatureFlagChange, onFeatureFlagChange);
            return function () { return _this.listeners.delete(onFeatureFlagChange); };
        };
        this.removeAllListeners = function () {
            _this.listeners.clear();
        };
        this.identifyUser = function (userId) {
            var _a;
            if (_this.lastIdentifiedUserId === userId)
                return;
            (_a = FlagManager.ldClient) === null || _a === void 0 ? void 0 : _a.identify({
                key: userId,
            }).then(function () {
                var _a;
                _this.lastIdentifiedUserId = userId;
                (_a = _this.onIdentiferChange) === null || _a === void 0 ? void 0 : _a.call(_this);
            }).catch(function (err) {
                _this.showLog && console.error(err);
            });
        };
        this.waitUntilReady = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = FlagManager.ldClient) === null || _a === void 0 ? void 0 : _a.waitUntilReady().catch(function (err) { return _this.showLog && console.error(err); }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.prepareFeatureSwitches = function (defaultFS) {
            if (!FlagManager.ldClient)
                return {};
            var res = {};
            Object.keys(defaultFS).forEach(function (key) {
                res[key] = FlagManager.ldClient.variation(key, defaultFS[key]);
            });
            return res;
        };
        this.onLDFlagChange = function (payload) {
            var flagValues = Object.keys(payload).map(function (key) { return ({
                key: key,
                value: payload[key].current,
            }); });
            flagValues.forEach(function (_a) {
                var key = _a.key, value = _a.value;
                // only take boolean feature flag
                return typeof value === "boolean" &&
                    _this.listeners.forEach(function (listener) { return listener(key, value); });
            });
        };
        this.startListening = function () {
            var _a;
            (_a = FlagManager.ldClient) === null || _a === void 0 ? void 0 : _a.on("change", _this.onLDFlagChange);
        };
        this.showLog = showLog;
        this.startListening();
    }
    FlagManager.init = function (clientSideKey, option, ldOptions, userIdentifier) {
        var user = {
            key: userIdentifier || "not_provided",
        };
        var options = __assign({ bootstrap: "localStorage" }, ldOptions);
        var client = launchdarkly_js_client_sdk_1.initialize(clientSideKey, user, options);
        FlagManager.ldClient = client;
        return new FlagManager(option);
    };
    FlagManager.featureSwitches = {};
    FlagManager.setFeatureSwitches = function (fs) {
        FlagManager.featureSwitches = __assign(__assign({}, FlagManager.featureSwitches), fs);
    };
    return FlagManager;
}());
exports.FlagManager = FlagManager;
